import React from "react";

const SUBSCRIBE_URL = "https://the-wealthy-miner.mn.co/";

const DetailsSection: React.FC = () => {
  return (
    <section className="bg-white pb-10 md:pb-12">
      <div className="w-full max-w-[1200px] mx-auto lg:px-6">
        <article className="w-full lg:w-[83.17%] mx-auto lg:rounded-b-[16px] rounded-none bg-[#EDF1F9] p-5 md:pt-10 md:pb-10 md:px-24 text-[#1f2d3d] font-[500] text-[17px] md:text-[14px] leading-[1.6]">
          {/* Intro block: text left, Rob avatar right - same as winning-stock-pick */}
          <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6 mb-8">
            <p className="flex-1 order-2 md:order-1">
            At <strong>The Wealthy Miner</strong>, guided by expert mining analyst and investor <strong>Rob Bruggeman</strong>, we deliver premium insights into undervalued junior mining stocks—focusing on gold, silver, copper, and critical metals with strong assets, top jurisdictions, and game-changing catalysts. Rob's in-depth research, video breakdowns, and timely picks empower subscribers to spot opportunities early and build wealth in the volatile mining sector.
            </p>
            <div className="flex justify-center md:justify-end shrink-0 order-1 md:order-2">
              <img
                src="/images/RobertBruggeman.webp"
                alt="Rob Bruggeman"
                className="rounded-full object-cover object-[center_18%] bg-[#0B6054]"
                style={{ width: "194.76px", height: "204px" }}
              />
            </div>
          </div>
          <hr className="my-5 border-0 h-[3px] bg-[#FFFF]" />

          {/* Real Results - dark text */}
          <h2 className="text-[22px] md:text-[24px] font-[400] text-[#1f2d3d] mb-3 leading-[110%]">
            <strong>
            Proven Results: Two Recent Picks That Have Delivered Over 100–200% Gains—And Counting            </strong>
          </h2>

          <p>
          Rob's recommendations aren't just theories—they drive real, outsized returns. Here's how two of his 2025 picks have already rewarded subscribers handsomely, proving that <strong>one solid win can easily cover your subscription costs for years </strong>(our annual plan is just $699—imagine tripling your investment in months while gaining ongoing access to more ideas).
          </p>

          {/* Success Story #1 – separate label above the card */}
          <div
            className="mt-6 w-fit rounded-t-lg px-3 py-1.5 text-white font-bold text-[18px] md:text-[24px] leading-tight"
            style={{ background: '#D4A129' }}
          >
            Success Story #1:
          </div>
          <div
            className="rounded-b-xl rounded-tr-xl border-2 pb-5 pt-5 px-5 md:px-6"
            style={{ backgroundColor: 'rgb(248, 248, 248)', borderColor: '#D4A129' }}
          >
              <h3 className="text-[#1f2d3d] font-bold text-[17px] md:text-[18px] leading-snug mb-3">
              Gold X2 Mining (TSXV: AUXX; OTCQB: GSHRF) – Over 100% Gains in Under Three Months              </h3>
              <p className="">
              On November 17, 2025, Rob flagged <strong>Gold X2 Mining</strong> as a <strong>NEW PICK!</strong> with massive potential.
              Key highlights from Rob's analysis:
                            </p>
              <p className="mb-2">Key highlights from Rob&apos;s analysis:</p>
              <ul className="list-disc pl-10 space-y-1 mb-4">
                <li>Resource estimate boasting <strong>over 6 million ounces of gold</strong> at the Moss project.</li>
                <li>At least half open-pittable in a stellar location near Thunder Bay, Ontario—excellent infrastructure and jurisdiction.</li>
                <li>All the traits majors crave for acquisition and development: scale, economics, and future mine viability.</li>
                <li>Near-term catalyst: A mineral resource update and <strong>Preliminary Economic Assessment (PEA)</strong> by G Mining, expected mid-December 2025, projecting <strong>~275 koz annual gold production</strong>.</li>
              </ul>
              <p className="mb-3">
                Rob shared a detailed video thesis, making the case crystal clear. Subscribers who bought around <strong>51 cents CAD</strong> watched the stock climb to a high of <strong>$1.44 CAD</strong>—and it&apos;s currently trading at <strong>$1.10 CAD</strong> as of February 4, 2026.
              </p>
              <p>
                <strong>Result: </strong>More than <strong>doubling your money</strong> in less than three months, fueled by the PEA&apos;s confirmation of robust economics (e.g., ~265,000 oz/year over 13+ years and top-tier NPV/IRR).
              </p>
          </div>
          {/* Success Story #2 – separate label above the card */}
          <div
            className="mt-6 w-fit rounded-t-lg px-3 py-1.5 text-white font-bold text-[18px] md:text-[24px] leading-tight"
            style={{ background: '#607D8B' }}
          >
            Success Story #2:
          </div>
          <div
            className="rounded-b-xl rounded-tr-xl border-2 pb-5 pt-5 px-5 md:px-6"
            style={{ backgroundColor: 'rgb(248, 248, 248)', borderColor: '#607D8B' }}
          >
              <h3 className="text-[#1f2d3d] font-bold text-[17px] md:text-[18px] leading-snug mb-3">
              Kingfisher Metals (TSXV: KFR) – Over 200% Gains in Under Six Months             </h3>
              <p className="">
              In August 2025, Rob recommended Kingfisher Metals as a high-upside exploration play in BC's Golden Triangle. Subscribers grabbed shares between 20 and 30 cents CAD.
                            </p>
              <p className="mb-2">From Rob's initial deep dive, <em>"Kingfisher Metals – Fishing for a Porphyry in the Golden Triangle"</em>:</p>
              <ul className="list-disc pl-10 space-y-1 mb-4">
                <li><strong>A $37 million exploreco</strong> (at recommendation) with 849 km² of prime land and multiple porphyry targets on the Highway 37 project.</li>
                <li>Potential for <strong>10-bagger upside</strong> if a major porphyry hits—valuing the company at <strong>$250–$500 million+.</strong></li>
                <li>Elite team: Led by geo Dustin Perry, with advisors like Charlie Grieg (Golden Triangle expert) and backers including Alex Gubbins and Larry Childress. Exploration-focused budget (no promo waste).</li>
                <li>Catalyst: 7,500-meter drill program with early visuals of broad potassic alteration (e.g., 478 meters in one hole). Assays in early September 2025 could expand historic intercepts like 347 meters of 0.33% copper and 0.39 g/t gold.</li>
              </ul>
              <p className="mb-3">
              Backed by Rob's write-up and video, this pick soared on strong results. Shares hit a recent high of <strong>90 cents CAD</strong> and are now at <strong>82 cents CAD</strong> as of February 3, 2026.              </p>
              <p>
                <strong>Result:Tripling (or more)</strong> your investment in under six months, driven by confirmed porphyry mineralization and major interest in the region's copper-gold assets.
              </p>
              <p className="mt-3">
              These aren't isolated flukes—Rob's track record shows consistent wins by identifying juniors with real catalysts and takeover potential amid soaring metals prices.              </p>
          </div>

          <h3 className="text-[25px] mt-10 md:text-[30px] font-[800] leading-[30px] text-[#1f2d3d] lg:text-left text-center">
          More Opportunities Await: 
          </h3>
          <h3 className="text-[25px] md:text-[30px] font-[800] leading-[30px] text-[#1f2d3d] mb-5 lg:text-left text-center">
          Recent Picks Still at Entry Levels          </h3>
          <p>And that's just the start. Rob has issued several fresh recommendations in recent months that are <strong>still trading near their initial levels</strong> —positioned for potential breakouts as catalysts approach.With gold at all-time highs, copper demand exploding for the energy transition, and majors on the hunt for acquisitions, now's the time to get in.</p>
          <p className="mt-3">
          One pick like these can pay for your subscription for years—imagine turning a modest stake into life-changing gains while accessing Rob's full portfolio and future ideas.          </p>
          

          <hr className="my-5 border-0 h-[3px] bg-[#FFFF]" />

          <h3 className="text-[25px] md:text-[30px] font-[800] leading-[30px] text-[#1f2d3d] mb-5 lg:text-left text-center">
          Why Subscribe to The Wealthy Miner Today?
          </h3>
          <ul className="list-disc pl-10 mt-2 space-y-2 mb-5">
            <li>
              <strong>Timely, High-Conviction Picks:</strong> Get Rob's recommendations first, with entry strategies to minimize risk and maximize reward.
            </li>
            <li>
              <strong>Expert Video & Analysis:</strong> Detailed videos, charts, and write-ups that break down the "why" behind every opportunity.
            </li>
            <li>
              <strong>Proven Value:</strong> Wins like Gold X2 and Kingfisher demonstrate how Rob's expertise turns volatility into profit.
            </li>
            <li>
              <strong>Ongoing Support:</strong> Portfolio updates, market commentary, community access, and alerts on emerging catalysts.
            </li>
          </ul>
          <p className="mb-3">
          Don't sit on the sidelines while juniors soar. Join the subscribers who've already profited big—and position yourself for the next wave.          </p>
          <p className="mb-5">
            <strong>Subscribe Now to The Wealthy Miner</strong> for instant access to Rob's insights, current picks, and more.
          </p>

          <a
            href={SUBSCRIBE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full rounded-md bg-[#0B6054] hover:bg-[#0a5349] text-white font-[700] text-[22px] md:text-[30px] leading-none py-3 md:py-4 transition-colors text-center"
          >
            Subscribe Today - Start Winning with Rob
          </a>
          <p className="text-[15px] px-5 text-[#1A2A44] font-[400] mt-2 text-center">
            Questions? Reach out or visit our FAQ. Past performance isn&apos;t a guarantee of future results.
            Junior mining investments carry high risk—always conduct your own research.
          </p>
        </article>
      </div>
    </section>
  );
};

export default DetailsSection;
